const appList = () => import('@/pages/content/app/index.vue');
const appForm = () => import('@/pages/content/app/form.vue');

export default [{
    path: '/content/app',
    component: appList,
    meta: [{
        name: '内容管理'
    },
    {
        name: 'APP版本管理',
        activeRoute: '/content/app'
    }]
}, {
    path: '/content/app/form',
    component: appForm,
    meta: [{
        name: '内容管理'
    }, {
        name: 'APP版本管理',
        url: '/content/app'
    }, {
        name: '新增/编辑',
        activeRoute: '/content/app'
    }]
}];